<template>
  <div>
    <div v-if="!hideTitleInDisplay" class="d-flex align-center mb-2">
        <h3 class="font-weight-bold mr-2 finalize-contract-text">
          {{ displayAsContractSection ? $t('finance.loanApplications.contract') : $t('finance.loanApplications.finalizeContract') }}
        </h3>
        <v-tooltip v-if="!displayAsContractSection" top color="#00BD73" max-width="350">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="ml-1"
              size="18"
              style="color: #00BD73; cursor: pointer;"
              v-bind="attrs"
              v-on="on"
            >
              mdi-information
            </v-icon>
          </template>
          <span>{{ $t('finance.loanApplications.ifYouWantUsToCollectTheApplicantSSignatureChooseYesAndAttachTheContractAfterYouSaveItWillBeSentToTheFarmerToSignInTheAppYouLlReceiveANotificationOnceSignedContractUploadIsOptionalEGIfTheContractIsAlreadySignedOrWillBeSignedOffline') }}</span>
        </v-tooltip>
        <v-tooltip v-else top color="#00BD73" max-width="350">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="ml-1"
              size="18"
              style="color: #00BD73; cursor: pointer;"
              v-bind="attrs"
              v-on="on"
            >
              mdi-information
            </v-icon>
          </template>
          <span>{{ $t('finance.loanApplications.ifYouWantUsToCollectTheApplicantSSignatureChooseYesAndAttachTheContractAfterYouSaveItWillBeSentToTheFarmerToSignInTheAppYouLlReceiveANotificationOnceSignedContractUploadIsOptionalEGIfTheContractIsAlreadySignedOrWillBeSignedOffline') }}</span>
        </v-tooltip>
      </div>
      <p v-if="!displayAsContractSection" class="finalize-contract-desc mb-4">
        {{ $t('finance.loanApplications.doYouWantUsToCollectTheContractSignatureIfYesAttachTheContractOptionalAndWeWillSendItToTheFarmerToSignInTheAppIfNoTheContractIsAlreadySignedOrWillBeSignedOfflineAfterYouAttachAndSaveTheContractWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned') }}
      </p>
      <template v-if="!displayAsContractSection">
      <div class="mb-4">
        <div class="finalize-contract-subheading mb-2">{{ $t('finance.loanApplications.doYouWantUsToCollectTheContractSignature') }}</div>
        <v-radio-group :value="signInApp" @input="$emit('update:signInApp', $event)" hide-details class="mt-0 finalize-contract-radio-group" row :disabled="readonly">
          <v-radio
            :label="$t('finance.loanApplications.yesAttachTheContractAndWeLlSendItToTheFarmerToSignInTheApp')"
            :value="true"
            color="primary"
            class="finalize-contract-radio"
          />
          <v-radio
            :label="$t('finance.loanApplications.noContractIsAlreadySignedOrWillBeSignedOffline')"
            :value="false"
            color="primary"
            class="finalize-contract-radio"
          />
        </v-radio-group>
      </div>
      <div class="mb-4">
        <div class="font-weight-bold mb-1 finalize-contract-subheading">{{ $t('finance.loanApplications.attachContractOptional') }}</div>
        <p class="finalize-contract-desc mb-2">
          <template v-if="signInApp">
            {{ $t('finance.loanApplications.uploadTheUnsignedContractAfterYouAttachAndSaveItWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned') }}
          </template>
          <template v-else>
            {{ $t('finance.loanApplications.youMayUploadTheSignedContractForYourRecordsOrLeaveEmptyIfTheContractIsPrivateOrSignedOffline') }}
          </template>
        </p>
        <div
          :class="['dropZone', { 'dropZone-over': !readonly && contractDragOver, 'dropZone--readonly': readonly }]"
          @dragenter="!readonly && (contractDragOver = true)"
          @dragleave="!readonly && (contractDragOver = false)"
          @drop.prevent="!readonly && onContractDrop($event)"
        >
          <div
            class="dropZone-info d-flex justify-center align-center"
            @dragover.prevent
            @click="!readonly && triggerContractFileInput()"
          >
            <v-icon size="40" color="#0057BD">mdi-tray-arrow-up</v-icon>
            <div class="dropZone-upload-limit-info ml-3">
              <h2 class="blue-color underline mb-1">
                {{ $t('finance.loanApplications.selectFileToUploadTheContract') }}
              </h2>
              <p class="gray-color ma-0">{{ $t('finance.loanApplications.orDragAndDropHere') }}</p>
            </div>
          </div>
          <input
            ref="contractFileInput"
            type="file"
            accept=".pdf,application/pdf"
            @change="onContractFileSelected"
          />
        </div>
      </div>
      </template>
        <div v-if="contractFile" class="d-flex align-start mt-3">
          <div class="attachment-card contract-uploaded-card">
            <div class="attachment-icon">
              <span class="attachment-icon-badge">PDF</span>
              <v-icon small color="#135B00" class="attachment-download" @click.stop="downloadContract">
                mdi-download
              </v-icon>
              <v-icon v-if="!readonly" small color="#135B00" class="attachment-delete" @click.stop="removeContract">
                mdi-delete
              </v-icon>
            </div>
            <div class="attachment-label">{{ contractFile.name }}</div>
          </div>
        </div>
        <div v-if="contractS3Link" class="d-flex align-start mt-3">
          <div class="attachment-card contract-uploaded-card">
            <div class="attachment-icon">
              <span class="attachment-icon-badge">PDF</span>
              <v-icon small color="#135B00" class="attachment-download" @click.stop="downloadContractFromURL">
                mdi-download
              </v-icon>
            </div>
            <div class="attachment-label">{{ getFilenameFromURL(contractS3Link) }}</div>
          </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'FinalizeContract',
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    /** When true, show as "Contract" section: title "Contract", only attached file (no radio, no upload UI). Used for waiting_signatures view. */
    displayAsContractSection: {
      type: Boolean,
      default: false,
    },
    /** When true and displayAsContractSection, do not render the "Contract" heading/tooltip (parent shows a single Contract title). */
    hideTitleInDisplay: {
      type: Boolean,
      default: false,
    },
    signInApp: {
      type: Boolean,
      default: true,
    },
    contractFile: {
      type: Object,
      default: null,
    },
    contractS3Link: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      contractDragOver: false,
    };
  },
  methods: {
    triggerContractFileInput() {
      this.$refs.contractFileInput?.click();
    },
    onContractFileSelected(event) {
      const file = event.target.files?.[0];
      if (file && file.type === 'application/pdf') {
        this.$emit('update:contractFile', {
          name: file.name.length > 12 ? file.name.slice(0, 9) + '...' : file.name,
          file,
        });
      }
      event.target.value = '';
    },
    onContractDrop(event) {
      this.contractDragOver = false;
      const file = event.dataTransfer?.files?.[0];
      if (file && file.type === 'application/pdf') {
        this.$emit('update:contractFile', {
          name: file.name.length > 12 ? file.name.slice(0, 9) + '...' : file.name,
          file,
        });
      }
    },
    getFilenameFromURL(url) {
      const decoded = decodeURIComponent(url);
      const parts = decoded.split('_');
      return parts.slice(2).join('_');
    },  
    downloadContract() {
      if (this.contractFile?.file) {
        const url = URL.createObjectURL(this.contractFile.file);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.contractFile.file.name;
        a.click();
        URL.revokeObjectURL(url);
      }
    },
    downloadContractFromURL() {
      if (this.contractS3Link) {
        const a = document.createElement('a');
        a.href = this.contractS3Link;
        a.download = this.getFilenameFromURL(this.contractS3Link);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    removeContract() {
      this.$emit('update:contractFile', null);
    },
  },
};
</script>

<style scoped>
.finalize-contract-text {
  color: #333 !important;
}

.finalize-contract-desc {
  font-size: 13px;
  font-weight: 400;
  color: #333 !important;
}

.finalize-contract-subheading {
  font-size: 16px;
  font-weight: 700;
  color: #333 !important;
}

.finalize-contract-radio-group {
  flex-wrap: wrap;
}

.finalize-contract-radio-group >>> .v-radio {
  margin-right: 24px;
}

.finalize-contract-radio-group >>> .v-input--radio-group__input {
  flex-direction: row;
}

.finalize-contract-radio-group >>> .v-radio .v-label {
  font-size: 13px !important;
  font-weight: 400 !important;
  color: #333 !important;
}

.view-label {
  font-size: 14px;
  color: #555;
}

.attachment-card {
  width: 90px;
  height: 115px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.attachment-icon {
  width: 90px;
  height: 90px;
  background: #e5f8f1;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.attachment-icon-badge {
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.5px;
  color: #135b00;
}

.attachment-download {
  position: absolute;
  top: 4px;
  left: 4px;
  right: auto;
  cursor: pointer;
}

.attachment-delete {
  position: absolute;
  top: 4px;
  right: 4px;
  bottom: auto;
  cursor: pointer;
}

.dropZone {
  width: 100%;
  max-width: 480px;
  min-height: 120px;
  position: relative;
  border: 2px dashed #97a8b8;
  cursor: pointer;
}

.dropZone:hover {
  border: 2px solid #00bd73;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translate(0, -50%);
  text-align: center;
  font-size: 12px;
}

.dropZone-info .blue-color {
  color: #0057bd;
}

.dropZone-info .underline {
  text-decoration: underline;
}

.dropZone-info .gray-color {
  color: #9e9e9e;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-over {
  background: #5c5c5c;
  opacity: 0.8;
}

.dropZone--readonly {
  pointer-events: none;
  opacity: 0.85;
  cursor: default;
}

.attachment-label {
  margin-top: 4px;
  font-size: 12px;
  color: #333;
}
</style>
